import { makeStyles } from '@mui/styles';
const nextButtonStyles = makeStyles(() => ({
    container: {
        display: 'inline',
    },
    button: {
        maxWidth: 230,
    },
}), { name: 'Cfg_Alt_NextButton' });
export default nextButtonStyles;
//# sourceMappingURL=nextButton.styles.js.map